import React, { memo } from "react"
import { FaUserLock } from "react-icons/fa"
import { FcBusinessman, FcManager } from "react-icons/fc"
import { GoDeviceMobile } from "react-icons/go"
import { RiComputerLine } from "react-icons/ri"

import { GROUP } from "@shared/config"
import { Role } from "@shared/contexts"
import { isMobile } from "@shared/modules"

interface Props {
  role: Role
  isBlockedChat: boolean | undefined
  device: string
}

function Icon({ role, isBlockedChat, device }: Props) {
  if (isBlockedChat) return <FaUserLock className="icon-user" />

  switch (role) {
    case "STREAMER":
      return <FcBusinessman title="스트리머" className="icon-user" />
    case "MANAGER":
      return <FcManager title="매니저" className="icon-user" />
    default:
      if (isMobile(device))
        return (
          <GoDeviceMobile
            title="mobile"
            className={
              GROUP.UNVERIFIED.includes(role) ? "icon-anonymous" : "icon-user"
            }
          />
        )
      else
        return (
          <RiComputerLine
            title="pc"
            className={
              GROUP.UNVERIFIED.includes(role) ? "icon-anonymous" : "icon-user"
            }
          />
        )
  }
}

export default memo(Icon)
